module.exports = __webpack_public_path__ + "0c1a08812d5b63d0b83f9a8ad506b8a1.svg";